import { useState } from "react";
import { stringMin } from "../../core/function/function-generic";
import { ChevronUpIcon, ChevronDownIcon, CheckIcon } from "@heroicons/react/24/outline";

interface Props {
    nameInput?: string;
    labelName: string;
    onValueData: any;
    dataOption: any[]
}

export const DropdownList = ({ labelName, onValueData, dataOption, nameInput }: Props) => {
    const [valueSelect, setvalueSelect] = useState('')
    const [openSelect, setOpenSelect] = useState(false)

    const onValueSelect = (value: string) => {
        setvalueSelect(value)
        onValueData(value, nameInput)
        setOpenSelect(!openSelect)
    }

    return (
        <>
            <div className="dropdown border-input p-2.5 min-w-min">
                <div className="grid grid-cols-2 w-full">
                    <div className="dropdown-text-option w-40">
                        {valueSelect ? stringMin(valueSelect) : labelName}
                    </div>
                    <div className="flex justify-end" onClick={() => setOpenSelect(!openSelect)} >
                        {
                            openSelect ? (
                                <ChevronUpIcon className="w-4 text-[#007AFF]" />
                            ) : (
                                <ChevronDownIcon className="w-4 text-[#007AFF]" />
                            )
                        }
                    </div>
                </div>

                <div className={`dropdown-content w-full ${openSelect ? 'block' : 'p-none'}`}>
                    {
                        dataOption.map((res: string, index: number) => (
                            <div
                                key={res + index}
                                id={res}
                                className={
                                    `dropdown-container-div w-full
                                    grid grid-cols-2 dropdown-option-color
                                    ${valueSelect === res ? 'dropdown-active' : ''}`
                                }
                                onClick={() => onValueSelect(res)}
                            >
                                <div className="dropdown-text-option">
                                    {stringMin(res)}
                                </div>
                                <div className="flex justify-end" >
                                    {
                                        valueSelect === res ? (
                                            <CheckIcon className="w-4 text-[#007AFF]" />
                                        ) : (<div></div>)
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </>
    );
}